export const CASE_OPERATION_HISTORY_ACTION_TYPE_MAP = {
  add: 'ADD',
  delete: 'DELETE',
} as const

export const CASE_OPERATION_HISTORY_DOMAIN_TYPE_MAP = {
  case: 'CASE',
} as const
